import I from "../tilecache/TileCache.js";
import u from "../maps/WarpedMapList.js";
import l from "../tilecache/FetchableTile.js";
import { WarpedMapEvent as w, WarpedMapEventType as a } from "../shared/events.js";
import { getTileZoomLevelForScale as E, computeTilesCoveringRingAtTileZoomLevel as L, getTilesResolution as T, getTileZoomLevelResolution as R, getTilesAtScaleFactor as g } from "../shared/tiles.js";
import { computeBbox as A, webMercatorToLonLat as V, squaredDistance as m, bboxToCenter as v, bboxToDiameter as F } from "@allmaps/stdlib";
const O = 5, f = 0, b = 2, C = 4, M = 10, P = 0, D = 0.4, B = 1024 * 1024, W = 10;
class U extends EventTarget {
  warpedMapList;
  tileCache;
  mapsInPreviousViewport = /* @__PURE__ */ new Set();
  mapsInViewport = /* @__PURE__ */ new Set();
  mapsWithRequestedTilesForViewport = /* @__PURE__ */ new Set();
  viewport;
  constructor(e, s, r) {
    super(), this.tileCache = new I(e, r), this.warpedMapList = new u(s, r);
  }
  /**
   * Parses an annotation and adds its georeferenced map to this renderer's warped map list
   *
   * @async
   * @param {unknown} annotation
   * @returns {Promise<(string | Error)[]>}
   */
  async addGeoreferenceAnnotation(e) {
    return this.warpedMapList.addGeoreferenceAnnotation(e);
  }
  /**
   * Adds a georeferenced map to this renderer's warped map list
   *
   * @async
   * @param {unknown} georeferencedMap
   * @returns {Promise<string | Error>}
   */
  async addGeoreferencedMap(e) {
    return this.warpedMapList.addGeoreferencedMap(e);
  }
  loadMissingImageInfosInViewport() {
    return this.viewport ? Array.from(
      this.warpedMapList.getMapsByGeoBbox(this.viewport.geoRectangleBbox)
    ).map((e) => this.warpedMapList.getWarpedMap(e)).filter(
      (e) => !e.hasImageInfo() && !e.loadingImageInfo
    ).map((e) => e.loadImageInfo()) : [];
  }
  someImageInfosInViewport() {
    return this.viewport ? Array.from(
      this.findMapsInViewport(
        this.shouldAnticipateInteraction() ? M : 0
      )
    ).map((e) => this.warpedMapList.getWarpedMap(e)).map((e) => e.hasImageInfo()).some(Boolean) : !1;
  }
  shouldRequestFetchableTiles() {
    return !0;
  }
  // Should we anticipate user interaction (panning or zooming)
  // and hence buffer the viewport or get overview tiles
  shouldAnticipateInteraction() {
    return !1;
  }
  requestFetchableTiles() {
    if (!this.shouldRequestFetchableTiles())
      return;
    const e = [], s = [], r = this.findMapsInViewport(
      this.shouldAnticipateInteraction() ? f : 0
    ), t = this.findMapsInViewport(
      this.shouldAnticipateInteraction() ? b : 0
    ), n = this.findMapsInViewport(
      this.shouldAnticipateInteraction() ? C : 0
    ), i = this.findMapsInViewport(
      this.shouldAnticipateInteraction() ? M : 0
    );
    for (const o of this.warpedMapList.getWarpedMaps())
      o.resetForViewport();
    for (const o of n)
      e.push(
        ...this.getMapFetchableTilesForViewport(o, r)
      );
    if (this.shouldAnticipateInteraction())
      for (const o of i)
        s.push(
          ...this.getMapOverviewFetchableTilesForViewport(
            o,
            [
              ...e,
              ...s
            ],
            t
          )
        );
    this.tileCache.requestFetchableTiles([
      ...e,
      ...s
    ]), this.updateMapsForViewport([
      ...e,
      ...s
    ]), this.pruneTileCache(i);
  }
  findMapsInViewport(e = 0) {
    if (!this.viewport)
      return /* @__PURE__ */ new Set();
    const s = this.viewport, r = this.viewport.getProjectedGeoBufferedRectangle(e), t = A(
      r.map((n) => V(n))
    );
    return new Set(
      Array.from(
        this.warpedMapList.getMapsByGeoBbox(t)
      ).sort((n, i) => {
        const o = this.warpedMapList.getWarpedMap(n), p = this.warpedMapList.getWarpedMap(i);
        return o && p ? m(
          v(o.geoMaskBbox),
          s.geoCenter
        ) - m(
          v(p.geoMaskBbox),
          s.geoCenter
        ) : 0;
      })
    );
  }
  getMapFetchableTilesForViewport(e, s) {
    if (!this.viewport)
      return [];
    const r = this.viewport, t = this.warpedMapList.getWarpedMap(e);
    if (!t)
      return [];
    if (!t.visible)
      return [];
    if (!t.hasImageInfo())
      return [];
    if (F(t.getViewportMaskBbox(r)) < O)
      return [];
    const n = E(
      t.parsedImage.tileZoomLevels,
      t.getResourceToCanvasScale(r),
      P,
      D
    );
    t.setTileZoomLevelForViewport(n);
    const i = {
      maxDepth: 0,
      // maxDepth: 2,
      // minOffsetRatio: 0.00001,
      sourceIsGeographic: !1,
      destinationIsGeographic: !0
    }, o = r.getProjectedGeoBufferedRectangle(
      this.shouldAnticipateInteraction() ? f : 0
    ), p = t.projectedTransformer.transformBackward(
      [o],
      i
    )[0];
    if (t.setProjectedGeoBufferedViewportRectangleForViewport(
      o
    ), t.setResourceBufferedViewportRingForViewport(
      p
    ), !s.has(e))
      return [];
    const d = L(
      p,
      n,
      [t.parsedImage.width, t.parsedImage.height]
    ).map(
      (c) => new l(c, t)
    );
    return t.setFetchableTilesForViewport(d), d;
  }
  getMapOverviewFetchableTilesForViewport(e, s, r) {
    if (!this.viewport)
      return [];
    const t = this.warpedMapList.getWarpedMap(e);
    if (!t)
      return [];
    if (!t.visible)
      return [];
    if (!t.hasImageInfo())
      return [];
    const n = T(
      s.map((d) => d.tile)
    ), i = this.viewport.canvasResolution * W;
    if (n > i)
      return [];
    const o = t.parsedImage.tileZoomLevels.filter(
      (d) => R(d) <= B
      // Neglect zoomlevels that contain too many pixels
    ).sort(
      (d, c) => d.scaleFactor - c.scaleFactor
      // Enforcing default ascending order, e.g. from 1 to 16
    ).at(-1);
    if (t.setOverviewTileZoomLevelForViewport(o), !r.has(e))
      return [];
    if (!o || t.tileZoomLevelForViewport && o.scaleFactor <= t.tileZoomLevelForViewport.scaleFactor)
      return [];
    const h = g(
      o.scaleFactor,
      t.parsedImage
    ).map(
      (d) => new l(d, t)
    );
    return t.setOverviewFetchableTilesForViewport(h), h;
  }
  updateMapsForViewport(e) {
    this.mapsWithRequestedTilesForViewport = new Set(
      e.map((i) => i.mapId).filter((i, o, p) => p.indexOf(i) === o).sort((i, o) => {
        const p = this.warpedMapList.getMapZIndex(i), h = this.warpedMapList.getMapZIndex(o);
        return p !== void 0 && h !== void 0 ? p - h : 0;
      })
    ), this.mapsInPreviousViewport = this.mapsInViewport, this.mapsInViewport = this.findMapsInViewport();
    const s = Array.from(
      this.mapsInPreviousViewport
    ), r = Array.from(this.mapsInViewport), t = r.filter(
      (i) => !s.includes(i)
    ), n = s.filter(
      (i) => !r.includes(i)
    );
    for (const i of t)
      this.dispatchEvent(
        new w(a.WARPEDMAPENTER, i)
      );
    for (const i of n)
      this.clearMap(i), this.dispatchEvent(
        new w(a.WARPEDMAPLEAVE, i)
      );
    return {
      mapsEnteringViewport: t,
      mapsLeavingViewport: n
    };
  }
  pruneTileCache(e) {
    const s = /* @__PURE__ */ new Map();
    for (const r of this.warpedMapList.getWarpedMaps(
      e
    ))
      s.set(r.mapId, {
        tileZoomLevelForViewport: r.tileZoomLevelForViewport,
        overviewTileZoomLevelForViewport: r.overviewTileZoomLevelForViewport,
        resourceViewportRingBboxForViewport: r.resourceBufferedViewportRingBboxForViewport
      });
    this.tileCache.prune(s);
  }
  destroy() {
    this.tileCache.destroy(), this.warpedMapList.destroy();
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  clearMap(e) {
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  mapTileLoaded(e) {
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  mapTileRemoved(e) {
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  imageInfoLoaded(e) {
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  warpedMapAdded(e) {
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  warpedMapRemoved(e) {
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  preChange(e) {
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  transformationChanged(e) {
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  distortionChanged(e) {
  }
  addEventListeners() {
    this.tileCache.addEventListener(
      a.MAPTILELOADED,
      this.mapTileLoaded.bind(this)
    ), this.tileCache.addEventListener(
      a.MAPTILEREMOVED,
      this.mapTileRemoved.bind(this)
    ), this.warpedMapList.addEventListener(
      a.IMAGEINFOLOADED,
      this.imageInfoLoaded.bind(this)
    ), this.warpedMapList.addEventListener(
      a.WARPEDMAPADDED,
      this.warpedMapAdded.bind(this)
    ), this.warpedMapList.addEventListener(
      a.WARPEDMAPREMOVED,
      this.warpedMapRemoved.bind(this)
    ), this.warpedMapList.addEventListener(
      a.PRECHANGE,
      this.preChange.bind(this)
    ), this.warpedMapList.addEventListener(
      a.TRANSFORMATIONCHANGED,
      this.transformationChanged.bind(this)
    ), this.warpedMapList.addEventListener(
      a.DISTORTIONCHANGED,
      this.distortionChanged.bind(this)
    );
  }
  removeEventListeners() {
    this.tileCache.removeEventListener(
      a.MAPTILELOADED,
      this.mapTileLoaded.bind(this)
    ), this.tileCache.removeEventListener(
      a.MAPTILEREMOVED,
      this.mapTileRemoved.bind(this)
    ), this.warpedMapList.removeEventListener(
      a.IMAGEINFOLOADED,
      this.imageInfoLoaded.bind(this)
    ), this.warpedMapList.removeEventListener(
      a.WARPEDMAPADDED,
      this.warpedMapAdded.bind(this)
    ), this.warpedMapList.removeEventListener(
      a.WARPEDMAPREMOVED,
      this.warpedMapRemoved.bind(this)
    ), this.warpedMapList.removeEventListener(
      a.PRECHANGE,
      this.preChange.bind(this)
    ), this.warpedMapList.removeEventListener(
      a.TRANSFORMATIONCHANGED,
      this.transformationChanged.bind(this)
    ), this.warpedMapList.removeEventListener(
      a.DISTORTIONCHANGED,
      this.distortionChanged.bind(this)
    );
  }
}
export {
  U as default
};
//# sourceMappingURL=BaseRenderer.js.map
